class DataLayerHelper {
  // Must be run from client
  static pushEvent(event: string, data: any) {
    if (typeof window !== 'undefined' && (window as any).dataLayer) {
      (window as any).dataLayer.push({ event, ...data });
    }
  }
}

export default DataLayerHelper;
